/**
 * Csv Schema of CargaMedlog
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {CargaMedlog} from '@/model/resource/CargaMedlog'

/* TODO: review generated schema */
export class CsvCargaMedlogSchema extends Schema {
  readonly name = 'CsvCargaMedlog'

  readonly fieldSet: FieldSet<CargaMedlog> = {
    idCargaMedlogPk: schema => schema.model.idCargaMedlogPk,
    carga: schema => schema.model.carga?.$id ?? null,
    erro: schema => schema.model.erro,
  }
}
